/*
  HALO FAQ: abre e fecha as perguntas com a altura animada (a resposta ganha o efeito escolhido
  no CSS pela classe .is-open), uma pergunta por vez (opcional) e a entrada da lista na tela.
  Sem JavaScript, ou com movimento reduzido, o <details> abre e fecha sem animação.
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('halo-faq')) return;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

  class HaloFaq extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.ac = new AbortController();
      var on = { signal: this.ac.signal };
      var self = this;

      this.exclusive = this.hasAttribute('data-exclusive');
      this.animate = this.dataset.open !== 'nenhuma';
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-hf-item]'));

      this.items.forEach(function (item) {
        item.open = false;
        var summary = item.querySelector('summary');
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          self.toggle(item, !item.classList.contains('is-open'));
        }, on);
      });

      // Entrada na tela
      if (this.dataset.reveal !== 'nenhuma' && !reduceQuery.matches && 'IntersectionObserver' in window) {
        this.classList.add('is-armed');
        this.io = new IntersectionObserver(function (entries) {
          if (!entries[entries.length - 1].isIntersecting) return;
          self.classList.add('is-in');
          self.io.disconnect();
        }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
        this.io.observe(this);
      }

      // Editor de temas: selecionar uma pergunta abre ela.
      document.addEventListener('shopify:block:select', function (e) {
        var item = self.items.find(function (i) { return i === e.target || i.contains(e.target); });
        if (item) {
          self.classList.add('is-in');
          self.toggle(item, true);
        }
      }, on);
      document.addEventListener('shopify:block:deselect', function (e) {
        var item = self.items.find(function (i) { return i === e.target || i.contains(e.target); });
        if (item) self.toggle(item, false);
      }, on);
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      this.ac.abort();
      if (this.io) this.io.disconnect();
    }

    toggle(item, open) {
      if (open && this.exclusive) {
        this.items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) this.toggle(other, false);
        }, this);
      }

      var body = item.querySelector('[data-hf-body]');
      // Altura na tela agora (inclui uma animação em andamento), medida antes de cancelar.
      var current = body.getBoundingClientRect().height;
      if (item.anim) {
        item.anim.cancel();
        item.anim = null;
      }

      if (!this.animate || reduceQuery.matches || !body.animate) {
        item.open = open;
        item.classList.toggle('is-open', open);
        return;
      }

      if (open) {
        var from = item.open ? current : 0;
        item.open = true;
        requestAnimationFrame(function () {
          item.classList.add('is-open');
        });
        this.run(item, body, from, body.scrollHeight, null);
      } else {
        item.classList.remove('is-open');
        this.run(item, body, current, 0, function () {
          item.open = false;
        });
      }
    }

    run(item, body, from, to, done) {
      var duration = Math.min(520, Math.max(280, Math.abs(to - from) * 1.1));
      item.anim = body.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: duration, easing: EASE }
      );
      item.anim.onfinish = function () {
        item.anim = null;
        if (done) done();
      };
    }
  }

  customElements.define('halo-faq', HaloFaq);
})();
